"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncAttribute = void 0;
const types_1 = require("../types");
class AsyncAttribute {
    constructor(attr) {
        this.attribute = undefined;
        this.attribute = attr;
    }
    getAttribute() {
        return this.attribute;
    }
    getToken() {
        var _a;
        return (_a = this.getAttribute()) === null || _a === void 0 ? void 0 : _a[1];
    }
    static getFromAttributes(attrs) {
        const attr = attrs.getAttributes().find(attr => {
            if (Array.isArray(attr) &&
                attr[0] === types_1.ResponseAttributeTypes.async &&
                attr[1]) {
                return attr;
            }
        });
        return attr ? new AsyncAttribute(attr) : undefined;
    }
}
exports.AsyncAttribute = AsyncAttribute;
